<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text"> Chiusura Commessa </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="chiudiWOMulti" small v-bind="attrs" v-on="on">
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>

      <v-spacer></v-spacer>

      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="annullaChiudiWOMass" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-card-text class="mt-5" style="overflow-y: auto">
      <div>
        <span style="color: rgb(0, 0, 0); font-size: 18px">
          Confermi di voler chiudere tutti i Work Orders associati a questa
          commessa?
        </span>
      </div>
      <div class="my-5">
        <span style="color: rgb(0, 0, 0); font-size: 18px">
          <b>{{ work_order.cod_commessa }}</b>
        </span>
      </div>

      <!-- Tabella dei WO che verranno chiusi massivamente -->
      <v-data-table
        :headers="headers_fasi_chiusura"
        :items="items_fasi_chiusura"
      >
        <template v-slot:top>
          <v-toolbar color="indigo" dense>
            <v-toolbar-title class="white--text">
              Work Order in Chiusura
            </v-toolbar-title>
          </v-toolbar>
        </template>

        <!-- Etichetta dello stato -->
        <template v-slot:[`item.stato`]="{ item }">
          <span
            :style="{
              fontWeight: 'bold',
              color: item.utente_in_uso == null ? 'green' : 'red',
            }"
            >{{
              item.utente_in_uso == null
                ? "Disponibile per la chiusura"
                : "Non disponibile per la chiusura"
            }}</span
          >
        </template>

        <!-- Etichetta dell'operatore attuale -->
        <template v-slot:[`item.utente_in_uso`]="{ item }">
          <span>{{
            item.utente_in_uso == null ? "N/D" : item.utente_in_uso
          }}</span>
        </template>
      </v-data-table>
    </v-card-text>

    <!-- Overlay del dialog di chiusura massiva -->
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
        style="z-index: 20"
      ></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import moment from "moment/moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";

export default {
  name: "ChiusuraMassivaFasi",
  components: { SnackbarQV },
  props: {
    work_order: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      overlay: false,

      // Array
      headers_fasi_chiusura: [
        {
          text: "Cod. fase",
          sortable: false,
          value: "cod_fase",
        },
        {
          text: "Des. fase",
          sortable: false,
          value: "des",
        },
        {
          text: "Stato",
          sortable: false,
          value: "stato",
        },
        {
          text: "Operatore Attuale",
          sortable: false,
          value: "utente_in_uso",
        },
      ],
      items_fasi_chiusura: new Array(),
    };
  },
  computed: {},
  watch: {
    variabile: {
      immediate: true,
      handler() {},
    },
  },
  methods: {
    annullaChiudiWOMass() {
      this.$emit("annulla_chiudi_wo_mass");
    },
    chiudiWOMulti() {
      /* Controllo che tutti i WO nell'array dei WO da
       * chiudere abbiano l'ora di start e l'ora di stop. */

      if (
        this.items_fasi_chiusura.filter(
          (e) => e.utente_in_uso != null && e.utente_in_uso != ""
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Non ci devono essere WO in lavorazione."
        );
        return;
      }

      const arr_tmp = new Array();

      this.items_fasi_chiusura.forEach((f) => {
        const obj_tmp = {
          id_commessa: f.id_commessa,
          id_commessa_dettaglio: f.id_commessa_dettaglio,
          id_stato_fase: 1,
        };
        arr_tmp.push(obj_tmp);
      });

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "chiudimultiwocommessaitalproget",
          token: localStorage.user_token,
          id_commessa: this.work_order.id_commessa,
          chiudi_commessa: this.id_stato_commessa_chiusa,
          fasi: arr_tmp,
        },
      };

      // // Inserisco un overlay di caricamento.
      this.overlay = true;

      this.$store
        .dispatch("api", request)
        .then(async (res) => {
          // Tolgo l'overlay di caricamento.
          this.overlay = false;

          if (res.status === 200) {
            this.$emit("registrate_fasi_commessa");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          // Tolgo l'overlay di caricamento.
          this.overlay = false;

          // Stampo una snackbar di avviso.
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          // Stampo il log dell'errore in console.
          console.error(err);
        });
    },
    formatData(arg_data, arg_tipo = "full") {
      if (arg_data == null || arg_data == "") {
        return "N/D";
      } else {
        if (arg_tipo == "full") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          strRes += arg_data.substr(11, 8);
          return strRes;
        } else if (arg_tipo == "strict") {
          let strRes = "";
          strRes += arg_data.substr(8, 2);
          strRes += "/";
          strRes += arg_data.substr(5, 2);
          strRes += "/";
          strRes += arg_data.substr(0, 4);
          strRes += " ";
          return strRes;
        }
      }
    },
    getWOChiusura() {
      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getworkorders",
          token: localStorage.getItem("user_token"),
          id_articolo: this.work_order.id_articolo,
          cod_commessa: this.work_order.cod_commessa,
          filtroEM: "1",
        },
      };

      this.overlay = true;

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Fermo l'overlay di caricamento.
          this.overlay = false;

          if (res.status === 200) {
            // Svuoto l'array che contiene i WO da chiudere.
            this.items_fasi_chiusura = new Array();

            /* Metto fra i WO da chiudere solo quelli che non hanno
             * ancora raggiunto la quantità richiesta dalla commessa. */
            res.data
              .filter((e) => e.pezzi_registrati < e.quantita)
              .forEach((elem) => {
                if (elem.pezzi_registrati < elem.quantita) {
                  elem.data_start = moment().format("YYYY-MM-DD");
                  elem.ora_start = "";
                  elem.data_stop = moment().format("YYYY-MM-DD");
                  elem.ora_stop = "";
                  elem.calendario_data_start = false;
                  elem.calendario_data_stop = false;
                  elem.calendario_ora_start = false;
                  elem.calendario_ora_start = false;
                  this.items_fasi_chiusura.push(elem);
                }
              });

            return true;
          } else {
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, impossibile caricare i dati."
            );

            return false;
          }
        })
        .catch((e) => {
          console.error(e);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, impossibile caricare i dati."
          );

          return false;
        });
    },
  },
  created() {},
  mounted() {
    this.getWOChiusura();
  },
};
</script>
<style scoped>
</style>